module.exports = __webpack_public_path__ + "img/chengli2.ddd566cb.png";